import { createAction } from "@reduxjs/toolkit";
export const FETCH_DOMAIN_CALL_COUNT = 'FETCH_DOMAIN_CALL_COUNT';
export const fetchDomainCallCountAction = createAction(FETCH_DOMAIN_CALL_COUNT);